export default class Price {

    getPrice()
    {
        return this.price;
    }

    /**
     * @param {Number} mileage meters
     */
    constructor(mileage) {
        this.mileage = mileage;
        this.price   = null;
        this.setPrice();
    }

    getHelper() {
        return '1€ du km + 49€ de prise en charge (minimum 99€)'
            + '\n'
            + 'De 0 km jusqu\'à 50 km : 99€'
            + '\n'
            + '53 km : 53X1 + 49€ de prise en charge = 102€'
            + '\n'
            + '150 Km : 150X1€ + 49€ de prise en charge = 199€'
            + '\n'
            + '9455 Km : 9455X1€ + 49€ de prise en charge = 9504€'
            ;
    }

    /**
      * La règle est :  1€ du km + 49€ de prise en charge (minimum 99€)
      * Soit :
      * → De 0 km jusqu'à 50 km : 99€
      * → 53 km : 53X1 + 49€ de prise en charge = 102€
      * → 150 Km : 150X1€ + 49€ de prise en charge = 199€
      * → 9455 Km : 9455X1€ + 49€ de prise en charge = 9504€
     */
    setPrice() {
        // arrondi en kms
        const mileage = (this.mileage/1000)|0;

        const lumpSum = 49;

        if(mileage <= 50) {
            this.price = 99;
        } else if(mileage > 50) {
            this.price = mileage + lumpSum;
        }

        console.log(this.price);
    }
}
